interface NumberFieldProps {
  value: number
  onChange: (value: number) => void
  /** For screen readers; the field usually sits in a labelled row. */
  label: string
  suffix?: string
  min?: number
  max?: number
  disabled?: boolean
}

/** A boxed number input with its unit shown inside the box, so it reads as one editable value. */
export function NumberField({ value, onChange, label, suffix, min, max, disabled = false }: NumberFieldProps) {
  return (
    <span
      className={`inline-flex items-center rounded border bg-white focus-within:border-marine focus-within:ring-2 focus-within:ring-marine/20 ${
        disabled ? 'border-ink-mid/20 opacity-60' : 'border-marine/30'
      }`}
    >
      <input
        type="number"
        aria-label={label}
        value={Number.isFinite(value) ? value : ''}
        min={min}
        max={max}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value === '' ? 0 : Number(event.target.value))}
        className="w-16 bg-transparent px-2 py-1.5 text-right text-sm font-bold text-ink focus:outline-none disabled:cursor-not-allowed"
      />
      {suffix && <span className="pr-2 text-xs text-ink-mid select-none">{suffix}</span>}
    </span>
  )
}
